module.exports = __webpack_public_path__ + "static/media/linkedin.d284320a.svg";